import React from "react";

import classnames from "classnames";
import { Field } from "formik";
import PropTypes from "prop-types";

import Text from "../Text";

import styles from "./Radio.module.scss";

function Radio({
  name,
  value,
  label,
  helpText,
  flex,
  type,
  labelElem,
  onChange: customOnChange,
}) {
  return (
    <Field name={name}>
      {({ field }) => {
        const { value: selected, onChange: onFieldChange, ...others } = field;
        const handleChange = e => {
          customOnChange(e);
          onFieldChange(e);
        };
        return (
          <div
            className={classnames(styles.container, type && styles[type])}
            style={{ flex }}
          >
            <input
              id={value}
              name={name}
              type="radio"
              value={value}
              checked={selected === value}
              onChange={handleChange}
              {...others}
            />
            <label htmlFor={value}>
              {labelElem ? (
                labelElem
              ) : (
                <>
                  <Text types={["sm", "medium", "inline"]}>{label}</Text>
                  {helpText ? (
                    <Text
                      className={styles["help-text"]}
                      types={["sm", "light", "grey-2"]}
                    >
                      {helpText}
                    </Text>
                  ) : null}
                </>
              )}
            </label>
          </div>
        );
      }}
    </Field>
  );
}

Radio.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  flex: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string,
  labelElem: PropTypes.element,
  helpText: PropTypes.string,
  onChange: PropTypes.func,
};

Radio.defaultProps = {
  required: false,
  flex: "1",
  type: "",
  label: "",
  labelElem: null,
  helpText: "",
  onChange: () => {},
};

Radio.styles = styles;

export default Radio;
